/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const FELDER_GRUPPEN = ["schriftart", "farben", "logos", "banner", "titel", "seitenfuss"] as const;
export type FelderGruppe = typeof FELDER_GRUPPEN[number];